import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Modal, Input} from 'antd';
import uuidv1 from 'uuid/v1';

@autobind
/**
 *
 */
export default class Tools extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    onChangeListItemInput: PropTypes.func,
    onChangeListItemSelect: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onAdd: PropTypes.func,
    option: PropTypes.bool,
  };
  static defaultProps = {
    items: [],
    option: true,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      name: '',
      position: '',
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {items} = this.props;
    const {showModal, name, position} = this.state;
    return (
      <div>
        <MaterialIcon
          className="add"
          style={{
            background: '#009fff',
            color: '#fff',
            fontSize: '1.1rem',
            padding: '0 3px',
          }}
          name="plus"
          onClick={() => this.setState({showModal: true, name: '', position: '',})}
        />
        <Modal
          onOk={() => {
            this.props.onAdd({
              dataIndex: uuidv1(),
              dataKey: uuidv1(),
              name: name,
              position: position,

            }, () => {
              this.setState({showModal: false, name: '', position: '',});
            });
          }}
          onCancel={() => this.setState({showModal: false, name: '', position: '',})}
          okText={app.translate('main.Add')}
          cancelText={app.translate('main.Cancel')}
          visible={showModal}
          title={'Add Signatory'}
        >
          <div style={{margin: 2}}>
            Name:
            <br/>
            <Input
              type={'text'}
              value={name}
              onChange={(e) => this.setState({name: e.target.value})}/>
          </div>
          <div style={{margin: 2}}>
            Position:
            <br/>
            <Input
              type={'text'}
              value={position}
              onChange={(e) => this.setState({position: e.target.value})}/>
          </div>
        </Modal>
      </div>
    );
  }
}
